import { createSlice } from "@reduxjs/toolkit";
import {
  ApprovedStatus,
  ValidStatusAuthorizationDocument,
} from "core/http/service/authorizationDocument/resTypes";

interface InitialState {
  formData: {
    approvedLevelId?: string;
    categoryId?: number | string;
    departmentId?: string;
    effectiveDateFrom?: string;
    effectiveDateTo?: string;
    isHighlight?: boolean;
    approvedStatus?: ApprovedStatus;
    issueDateFrom?: string;
    issueDateTo?: string;
    name?: string;
    authorizedId?: string;
    parentFieldId?: string;
    status?: ValidStatusAuthorizationDocument | string;
  };
  isSearching: boolean;
}

const initialState: InitialState = {
  formData: {
    name: "",
    status: "",
    categoryId: "",
    departmentId: "",
    approvedLevelId: "",
    authorizedId: "",
    parentFieldId: "",
  },
  isSearching: false,
};

const fromSearchAuthorizationDocumentSlice = createSlice({
  name: "fromSearchAuthorizationDocument",
  initialState,
  reducers: {
    updateSearchAuthorizationDocumentState: (state, action) => {
      state.isSearching = action.payload;
    },
    updateFormSearchAuthorizationDocument: (state, action) => {
      state.formData = {
        ...state.formData,
        ...action.payload,
      };
    },

    resetFormSearchAuthorizationDocument: () => {
      return { ...initialState };
    },
  },
});

export const {
  updateFormSearchAuthorizationDocument,
  resetFormSearchAuthorizationDocument,
  updateSearchAuthorizationDocumentState,
} = fromSearchAuthorizationDocumentSlice.actions;

export default fromSearchAuthorizationDocumentSlice.reducer;
